import { render, staticRenderFns } from "./LikeSolid.vue?vue&type=template&id=42454686&"
import script from "./LikeSolid.vue?vue&type=script&lang=ts&"
export * from "./LikeSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports